import React from 'react'

const CheckoutContext = React.createContext({
  user: {},
  order: {},
  updateOrder: () => {},
  updateUser: () => {},
  startLoading: () => {},
  stopLoading: () => {},
  logger: {},
  status: {
    isLoading: false,
    services: {
      avatax: true,
      bookshelf: true,
      braintree: true,
      intelligentSearch: true,
      relate: true,
    },
  },
})

export default CheckoutContext

// This function takes a component...
export const withCheckout = Component => props => (
  <CheckoutContext.Consumer>
    {checkoutProps => <Component {...props} {...checkoutProps} />}
  </CheckoutContext.Consumer>
)
